







import { IsMens } from '@/utils/app-setting';
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class CalendarButton extends Vue {
  // 'mens'版かどうか
  public isMens = IsMens()
  public calendarIconPass = require(this.isMens
    ? '@/assets/icon_calendar_blue.png'
    : '@/assets/icon_calendar_red.png')
}
